const PageUrl = (api: any) => ({
  searchPageURL: (findOptions: any) =>
    api.post("/pageURL/searchPageURL.php", {}, findOptions),
  createPageURL: (payload: { description: string; url: string }) =>
    api.post("/pageURL/createPageURL.php", {}, payload),
  updatePageURL: (payload: { description: string; url: string }) =>
    api.put("/pageURL/updatePageURL.php", {}, payload),
  deletePageURL: (pageURLId: number) =>
    api.remove("/pageURL/deletePageURL.php", {}, { pageURLId }),
  getPageUrlRelationship: (pageURLId: number) =>
    api.get(`/pageURL/getPageURLCategories.php?pageURLId=${pageURLId}`, {}, {}),
  addPageURLCategoryMember: (payload: { categoryId: number; pageURLId: number }) =>
    api.post("/pageURLCategory/addPageURLCategoryMember.php", {}, payload),
  deletePageURLCategoryMember: (pageURLId: number, categoryId: number) =>
    api.remove(
      "/pageURLCategory/deletePageURLCategoryMember.php",
      {},
      {categoryId, pageURLId }
    ),
});

export default PageUrl;